<template>
  <v-app :dark="dark">
    <div class="toolbar">
      <v-btn disabled to="archives">Previous news</v-btn>

      <v-btn v-if="dark" icon @click="toggleDark">
        <v-icon>far fa-lightbulb</v-icon>
      </v-btn>
      <v-btn v-else icon @click="toggleDark">
        <v-icon>fas fa-lightbulb</v-icon>
      </v-btn>

    </div>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  methods: {
    toggleDark() {
      this.dark = !this.dark;
    },
  },
  data() {
    return {
      dark: false,
    };
  },
};
</script>

<style>
  html, body {
    overflow: auto;
  }

  .toolbar {
    position: fixed;
    right: 0;
    z-index: 5;
  }
</style>
